import React from "react";
import { Button, Col, Spinner } from "react-bootstrap";
import styles from "./inputDropdown.module.css";
import { useMyContext } from '../../myContext'

const InputFieldWithoutDropDown = ({
  placeholder,
  label,
  conversionValueButton,
  image = "",
  disabled,
  value,
  onChange,
  errorMessage = "",
  forwardedRef,
  dropdown = "false",
  setCurrency,
  dropdownType = "",
  currencyOption,
  applyCoupon,
  error,
  loader
}) => {

  const { themeColor } = useMyContext('');

  return (
    <>
        <span className={styles.inputLabel}>{label}</span>
        {/* <Col
            className={styles.inputfieldDiv}
            style={dropdown === true ? { display: "flex" } : {}, error ? border : "1px solid red" : border : ""}
        > */}
            <Col
  className={styles.inputfieldDiv}
  style={{
    ...(dropdown === true && { display: "flex" }), // Add conditional styles for dropdown
    ...(error ? { border: "1px solid red" } : {}), // Add conditional styles for error
  }}
>
        <input
            ref={forwardedRef}
            type={"text"}
            className={styles.inputNumber}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={(e) => {
                if (e.key === "." || e.key === "-") e.preventDefault();
            }}
        ></input>
        <Button className={styles.button} onClick={() => applyCoupon()} disabled={disabled}>
        {loader && <Spinner animation="border" className={styles.spinnerColor} style={{borderColor: themeColor, borderRightColor: "white"}}/>}
          Apply
          </Button>
        </Col>
        {errorMessage !== "" && (
            <div className={styles.errorState}>{errorMessage}</div>
        )}
    </>
  );
};

export default InputFieldWithoutDropDown;
